import NewClient from "./Container"

export default NewClient
